import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { springfieldVtConfig } from "./data";

export default function SpringfieldVtPage() {
  return <CityPageTemplate config={springfieldVtConfig} />;
}